import * as React from 'react'
import { ApplicationState } from '../../store'
import { RouteComponentProps } from 'react-router'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import {
    TextFormField,
    NumberFormField,
    ToggleFieldController,
    SelectFormFieldController,
    Row,
    Col,
    Grid,
    SectionTitle,
    WysiwygFieldController,
    ToggleButtonsSmallFieldController,
    FormFieldWrapper,
    Card,
    defaultLabelSort,
    LabelFormField,
    SelectFormField,
} from 'traveldesk-ui'
import { nameof } from 'traveldesk-ui'
import parseId from '../../services/parseId'
import { actionCreators as toursActions } from '../../store/Tours'
import { actionCreators as ticketsActions } from '../../store/Tickets'
import { actionCreators as citiesActions } from '../../store/Cities'
import { actionCreators as timeSlotsActions } from '../../store/TimeSlots'
import Offer from '../../models/Offer'
import { MediaSelector } from 'traveldesk-ui'
import { Photo } from 'traveldesk-ui'
import { ScrollToTop, SelectOptionModel, IdFormField } from 'traveldesk-ui'
import { offerBookingTypeOptions } from './../../models/Offer'
import { Buttons, ContainerWithPadding } from 'traveldesk-ui'
import { LoadingSection } from '../../components/LoadingSection'
import { BookingType, BookingTypeOptions } from '../../models/OfferBookingType'
import { OffersTicketTypesType } from '../../models/OfferTicketType'
import Cancellations from '../../components/Cancellations'
import CancellationPolicy from './../../models/CancellationPolicy'
import NoDefaultValue from './../../components/Ui/NoDefaultValue'
import { OfferPrivateType, OfferPrivateTypeOptions } from '../../models/OfferPrivateType'
import ExternalIntegrationsApiService, { ExternalToursFilterModel } from '../../services/ExternalIntegrationsApiService'
import { TourImportModel } from '../TourImport/TourImportModel'
import { useLanguagesManageTable } from '../../effects/useLanguages'
import OffersApiService from '../../services/OffersApiService'
interface Props extends RouteComponentProps<{ tourId: string; ticketId: string }> { }

const OfferForm = (props: Props) => {
    const dispatch = useDispatch()
    const languages = useLanguagesManageTable()
    const auth = useSelector((state: ApplicationState) => state.auth)
    const [externalProviders, setExternalProviders] = React.useState<SelectOptionModel[]>([])
    const [externalProducts, setExternalProducts] = React.useState<SelectOptionModel[]>([])
    const [externalProductDetails, setExternalProductDetails] = React.useState<TourImportModel | undefined>(undefined)
    const externalProductsRequestId = React.useRef<number>(0)
    const externalTourDetailsRequestId = React.useRef<number>(0)
    const [translatedToLanguages, setTranslatedToLanguages] = React.useState<SelectOptionModel[]>([])
    const [previewLanguageId, setPreviewLanguageId] = React.useState<number>(0)
    const [newTranslationLanguageId, setNewTranslationLanguageId] = React.useState<number | undefined>(undefined)
    const [isPublishedToTraveldesk, setIsPublishedToTraveldesk] = React.useState<boolean>(false)
    const [isUpdatingPublication, setIsUpdatingPublication] = React.useState<boolean>(false)
    const citiesOptions = useSelector((state: ApplicationState) => {
        return state.cities.citiesOptions
    })
    const tickets = useSelector((state: ApplicationState) => {
        return state.tickets.types
    })
    const accountSettings = useSelector((state: ApplicationState) => state.account.settings)
    const Localization = useSelector((state: ApplicationState) => state.localization.locale)
    const ticketsOptions = React.useMemo(() => {
        return tickets.map((x) => ({ value: x.id, label: x.shortName }))
    }, [tickets, Localization])
    const tour = useSelector((state: ApplicationState) => {
        return state.tours.tour
    })
    const offer = useSelector((state: ApplicationState) => {
        return state.tours.offer
    })
    const offersOptions = useSelector((state: ApplicationState) => {
        return state.tours.offersOptions
    })
    const timeSlots = useSelector((state: ApplicationState) => {
        return state.timeSlots.timeSlotsGroups
    })
    const requestExternalTourDetails = async (externalTourId?: string, externalProviderId?: number) => {
        const requestId = ++externalTourDetailsRequestId.current
        setExternalProductDetails(undefined)
        if (!externalTourId || !externalProviderId) {
            return
        }

        const response = await ExternalIntegrationsApiService.getExternalTour(
            dispatch,
            String(externalTourId),
            externalProviderId.toString(),
        )
        if (requestId !== externalTourDetailsRequestId.current) {
            return
        }
        if (response.IsOk && response.Content) {
            setExternalProductDetails(response.Content)
        }
    }
    const requestExternalProviders = async () => {
        const response = await ExternalIntegrationsApiService.getApiIntegrations(dispatch)
        if (response.IsOk && response.Content) {
            setExternalProviders(response.Content.map(x => ({ label: `${x.label} (${x.value})`, value: x.value })))
        }
    }
    React.useEffect(() => {
        if (auth.authData?.isExternalIntegrations) {
            requestExternalProviders()
        }
    }, [auth.authData?.isExternalIntegrations])
    const timeSlotsOptions = React.useMemo(
        () =>
            timeSlots.reduce((res, tsg) => {
                return res.concat(
                    tsg.timeSlots.map((ts) => ({
                        label: `${ts.name} (${ts.id})`,
                        value: ts.id,
                        level: 2,
                        url: `/timeslots/${tsg.id}/${ts.id}`
                    }))
                    // {
                    //     label: tsg.name,
                    //     value: -tsg.id,
                    //     level: 1,
                    //     options: tsg.timeSlots.map((ts) => ({
                    //         label: ts.name,
                    //         value: ts.id,
                    //         level: 2,
                    //     })),
                    // },
                )
            }, [] as SelectOptionModel[]).sort(defaultLabelSort),
        [timeSlots],
    )
    const onHeroImageChanged = (photo: Photo) => {
        setHeroImageId(photo.id)
    }
    const onDeletePhoto = (photo: Photo) => {
        setPhotos(photos.filter((x) => x.id != photo.id))
    }
    const onSelectPhotos = (newPhoto: Photo[]) => {
        setPhotos(photos.concat(newPhoto))
    }
    const bookingTypeOptions = React.useMemo(() => offerBookingTypeOptions(Localization), [Localization])
    const [photos, setPhotos] = React.useState(offer?.photos ?? [])
    const [heroImageId, setHeroImageId] = React.useState(offer?.heroImageId)
    const [cancellation, setCancellation] = React.useState(
        (offer?.isOverrideTourCancellationPolicy ? offer?.cancellationPolicy : tour?.cancellationPolicy) ?? [],
    )
    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
        watch,
        reset,
        setValue,
    } = useForm<any>({
        defaultValues: Object.assign({}, offer, {
            ticketTypesAdult: offer?.ticketsTypes.filter(x => x.type == OffersTicketTypesType.Adult).map(x => x.ticketTypeId),
            ticketTypesChild: offer?.ticketsTypes.filter(x => x.type == OffersTicketTypesType.Child).map(x => x.ticketTypeId),
            ticketTypesInfant: offer?.ticketsTypes.filter(x => x.type == OffersTicketTypesType.Infant).map(x => x.ticketTypeId)

        })
    })
    const data = watch()
  
    const onExternalProviderChanged = React.useCallback(() => {
        setValue('externalTourId', '')
        setValue('externalOfferId', '')
        setValue('externalTicketTypeAdultId', '')
        setValue('externalTicketTypeChildId', '')
        setValue('externalTicketTypeInfantId', '')
        setExternalProducts([])
        setExternalProductDetails(undefined)
    }, [setValue])
    const onExternalTourChanged = React.useCallback(() => {
        setValue('externalOfferId', '')
        setValue('externalTicketTypeAdultId', '')
        setValue('externalTicketTypeChildId', '')
        setValue('externalTicketTypeInfantId', '')
        setExternalProductDetails(undefined)
    }, [setValue])
    const onExternalOfferChanged = React.useCallback(() => {
        setValue('externalTicketTypeAdultId', '')
        setValue('externalTicketTypeChildId', '')
        setValue('externalTicketTypeInfantId', '')
    }, [setValue])
    React.useEffect(() => {
        setPhotos(offer?.photos ?? [])
        setHeroImageId(offer?.heroImageId)
        setIsPublishedToTraveldesk(offer?.isPublished ?? false)
        setCancellation(
            (offer?.isOverrideTourCancellationPolicy ? offer.cancellationPolicy : tour?.cancellationPolicy) ??
            cancellation,
        )
        reset(Object.assign({}, offer, {
            ticketTypesAdult: offer?.ticketsTypes.filter(x => x.type == OffersTicketTypesType.Adult).map(x => x.ticketTypeId),
            ticketTypesChild: offer?.ticketsTypes.filter(x => x.type == OffersTicketTypesType.Child).map(x => x.ticketTypeId),
            ticketTypesInfant: offer?.ticketsTypes.filter(x => x.type == OffersTicketTypesType.Infant).map(x => x.ticketTypeId)
        }))
    }, [offer])
    const getTranslatedToLanguages = async (offerId: number) => {
        const translatedToResponse = await OffersApiService.getOfferTranslatedTo(dispatch, offerId)
        if (translatedToResponse.IsOk && translatedToResponse.Content) {
            const options = translatedToResponse.Content.sort(defaultLabelSort)
            if (options && options.length > 0) {
                options.unshift({ value: 0, label: 'Default' })
            }
            options.unshift({ value: -1, label: 'Add new' })
            setTranslatedToLanguages(options)
            return
        }

        alert("Couldn't get offers translations: " + translatedToResponse.ErrorMessage)
    }
    React.useEffect(() => {
        if (offer?.id) {
            getTranslatedToLanguages(offer.id)
        } else {
            setTranslatedToLanguages([])
            setPreviewLanguageId(0)
            setNewTranslationLanguageId(undefined)
        }
    }, [offer?.id])
    React.useEffect(() => {
        ScrollToTop()
        const id = parseId(props.match.params.ticketId)
        const tourId = parseId(props.match.params.tourId)
        if (typeof tourId == undefined) {
            props.history.push('/tours')
        }
        if (typeof id == undefined) {
            props.history.push(`/tours${props.match.params.tourId}`)
        }
        if (!tour || tour.id != tourId) {
            dispatch(toursActions.manageTour(tourId || 0, accountSettings))
        }
        if (!offersOptions || offersOptions.length == 0) {
            dispatch(toursActions.requestOffersOptions())
        }
        if (tickets.length == 0) {
            dispatch(ticketsActions.requestTypes())
        }
        if (citiesOptions.length == 0) {
            dispatch(citiesActions.requestCitiesOptions())
        }
        if (timeSlots.length == 0) {
            dispatch(timeSlotsActions.requestTimeSlotsGroups())
        }
    }, [props.match.params.tourId, props.match.params.ticketId])
    React.useEffect(() => {
        ScrollToTop()
        const id = parseId(props.match.params.ticketId)
        const tourId = parseId(props.match.params.tourId)
        dispatch(toursActions.manageOffer(id || 0, tourId || 0, accountSettings, previewLanguageId))
    }, [props.match.params.ticketId, previewLanguageId])
    const addTranslation = async () => {
        const offerId = offer?.id ?? 0
        const languageId = newTranslationLanguageId
        if (offerId && languageId) {
            await OffersApiService.translateOffer(dispatch, offerId, languageId)
            setNewTranslationLanguageId(undefined)
            setPreviewLanguageId(languageId)
        }
    }
    const onSubmit = (data: any) => {
        data.heroImageId = heroImageId
        data.photos = photos
        data.cancellationPolicy = data.isOverrideTourCancellationPolicy ? cancellation : [];
        const offer = Offer.Create(data, parseInt(props.match.params.tourId), accountSettings)
        dispatch(toursActions.saveOffer(offer))
    }
    const togglePublishedToTraveldesk = async () => {
        if (!offer?.id || isUpdatingPublication) {
            return
        }

        setIsUpdatingPublication(true)
        const response = await OffersApiService.setPublished(dispatch, offer.id, !isPublishedToTraveldesk)
        if (response.IsOk && typeof response.Content === 'boolean') {
            setIsPublishedToTraveldesk(response.Content)
        } else {
            alert("Couldn't update the TravelDesk publication status: " + response.ErrorMessage)
        }
        setIsUpdatingPublication(false)
    }
    const requestExternalProducts = async (externalProviderId: number | undefined) => {
        const requestId = ++externalProductsRequestId.current
        ++externalTourDetailsRequestId.current
        setExternalProducts([])
        setExternalProductDetails(undefined)
        if (externalProviderId) {
            const filter = { page: 1, onPage: 1000 } as ExternalToursFilterModel
            const response = await ExternalIntegrationsApiService.getExternalTours(
                dispatch,
                externalProviderId.toString(),
                filter,
            )
            if (requestId !== externalProductsRequestId.current) {
                return
            }
            if (response.IsOk && response.Content) {
                setExternalProducts(response.Content.entities.map(x => ({
                    label: `${x.label} (${x.value})`,
                    value: String(x.value),
                })))
                return
            }
        }
    }
    React.useEffect(() => {
        const hasSelectedProvider = externalProviders.some(
            x => String(x.value) === String(data.externalProviderId),
        )
        requestExternalProducts(hasSelectedProvider ? data.externalProviderId : undefined)
    }, [data.externalProviderId, externalProviders])
    React.useEffect(() => {
        const hasSelectedTour = externalProducts.some(
            x => String(x.value) === String(data.externalTourId),
        )
        requestExternalTourDetails(
            hasSelectedTour ? String(data.externalTourId) : undefined,
            hasSelectedTour ? data.externalProviderId : undefined,
        )
    }, [data.externalTourId, data.externalProviderId, externalProducts])
    const selectedExternalOffer = React.useMemo(() => {
        return externalProductDetails?.offers?.find(
            x => String(x.externalId) === String(data.externalOfferId),
        )
    }, [externalProductDetails, data.externalOfferId])
    const externalTicketTypes = React.useMemo(() => {
        return selectedExternalOffer?.ticketTypes?.filter(x => x.allowed !== false) ?? []
    }, [selectedExternalOffer])
    const hasExternalTicketTypes = externalTicketTypes.length > 0
    const externalTicketTypeOptions = React.useMemo(
        () => externalTicketTypes.map(x => ({ label: `${x.label} (${x.id})`, value: String(x.id) })),
        [externalTicketTypes],
    )
  
    return (
        <ContainerWithPadding>
            {tour && offer ? (
                <Grid>
                    <SectionTitle
                        title={Localization.getString(
                            offer.id
                                ? `${Localization.getString('Edit ticket')} '${offer.nameDisplay}' (${offer.nameInternal
                                })`
                                : Localization.getString('Add Ticket'),
                        )}
                    />
                    <Link className="a-back-to-list" to={`/tours/${props.match.params.tourId}`}>
                        {Localization.getString('Back to tour')}
                    </Link>
                    {offer.id > 0 && offer.supplierId > 1 && previewLanguageId <= 0 ? (
                        <Card>
                            <button
                                type='button'
                                className='button has-glow'
                                disabled={isUpdatingPublication}
                                onClick={togglePublishedToTraveldesk}>
                                {isUpdatingPublication
                                    ? Localization.getString('Updating...')
                                    : Localization.getString(
                                        isPublishedToTraveldesk
                                            ? 'Unpublish from TravelDesk'
                                            : 'Publish to TravelDesk',
                                    )}
                            </button>
                        </Card>
                    ) : null}
                    {translatedToLanguages && translatedToLanguages.length > 0 ? (
                        <Card>
                            <SelectFormField
                                label='Translations'
                                value={previewLanguageId}
                                onChange={(option: SelectOptionModel) => setPreviewLanguageId(option.value as number)}
                                options={translatedToLanguages}
                                placeholder='Default'
                            />
                            {previewLanguageId == -1 ? (
                                <>
                                    <SelectFormField
                                        label='Add New Translation'
                                        value={newTranslationLanguageId}
                                        onChange={(option: SelectOptionModel) => setNewTranslationLanguageId(option.value as number)}
                                        options={languages.languagesOptions}
                                        placeholder='Select language to translate to'
                                    />
                                    <button
                                        className='button has-glow'
                                        disabled={!newTranslationLanguageId}
                                        onClick={(e) => {
                                            e.preventDefault()
                                            addTranslation()
                                        }}>
                                        Add
                                    </button>
                                    <button
                                        className='button has-glow'
                                        style={{ background: 'white', color: 'black', marginLeft: 10 }}
                                        onClick={(e) => {
                                            e.preventDefault()
                                            setPreviewLanguageId(0)
                                            setNewTranslationLanguageId(undefined)
                                        }}>
                                        Cancel
                                    </button>
                                </>
                            ) : null}
                        </Card>
                    ) : null}
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Row>
                            <Col isNoMargin type="50">
                                <Card>
                                    <h3>{Localization.getString('Basic Details')}</h3>
                                    <IdFormField control={control} />

                                    <TextFormField
                                        label={Localization.getString('Ticket Code')}
                                        subLabel={Localization.getString('Internal name of the ticket')}
                                        isRequired
                                        register={register}
                                        options={{ required: Localization.getString('Ticket code is required') }}
                                        name={nameof<Offer>('nameInternal')}
                                        error={errors.nameInternal ? errors.nameInternal.message : ''}
                                    />
                                    <TextFormField
                                        label={Localization.getString('Ticket Display Name')}
                                        subLabel={Localization.getString('The name visible to the public')}
                                        isRequired
                                        register={register}
                                        options={{ required: Localization.getString('Ticket display name is required') }}
                                        name={nameof<Offer>('nameDisplay')}
                                        error={errors.nameDisplay ? errors.nameDisplay.message : ''}
                                    />
                                    <SelectFormFieldController
                                        name={nameof<Offer>('origin')}
                                        isRequired
                                        label={Localization.getString('Origin')}
                                        options={citiesOptions}
                                        isMultiple
                                        subLabel={Localization.getString(
                                            'Select the cities FROM which this is ticket is valid for purchase',
                                        )}
                                        control={control}
                                    />
                                    <SelectFormFieldController
                                        name={nameof<Offer>('privateType')}
                                        isRequired
                                        label={Localization.getString('Private Type')}
                                        options={OfferPrivateTypeOptions}
                                        control={control}
                                    />
                                    <NumberFormField
                                        register={register}
                                        label={`${Localization.getString('Minimum advanced payment')}, %`}
                                        min={0}
                                        subLabel={Localization.getString('MinPaymentSubheading')}
                                        max={100}
                                        name={nameof<Offer>('minimumAdvancedPayment')}
                                    />
                                    <NumberFormField
                                        register={register}
                                        label={Localization.getString('Min. Number of People')}
                                        isRequired
                                        min={1}
                                        options={{
                                            required: Localization.getString('Minimum number of people is required'),
                                        }}
                                        name={nameof<Offer>('minNumOfPeople')}
                                        error={errors.minNumOfPeople ? errors.minNumOfPeople.message : ''}
                                    />
                                    <NumberFormField
                                        register={register}
                                        label={Localization.getString('Max. Number of People')}
                                        isRequired
                                        min={1}
                                        options={{
                                            required: Localization.getString('Maximum number of people is required'),
                                        }}
                                        name={nameof<Offer>('maxNumOfPeople')}
                                        error={errors.maxNumOfPeople ? errors.maxNumOfPeople.message : ''}
                                    />
                                    <NumberFormField
                                        register={register}
                                        label={Localization.getString('Offer Duration in hours')}
                                        isRequired
                                        min={1}
                                        options={{
                                            required: Localization.getString('Minimum duration is 1 hour'),
                                        }}
                                        name={nameof<Offer>('numberOfHours')}
                                        error={errors.numberOfHours ? errors.numberOfHours.message : ''}
                                    />
                                    <ToggleFieldController
                                        name={nameof<Offer>('isDirectReporting')}
                                        label={Localization.getString('Is Direct Reporting')}
                                        control={control}
                                    />
                                    <ToggleFieldController
                                        name={nameof<Offer>('allowDirectCollection')}
                                        label={Localization.getString('Allow Direct Collection')}
                                        control={control}
                                    />
                                    <ToggleFieldController
                                        name={nameof<Offer>('isAppendTransactionFeeB2b')}
                                        label={Localization.getString('Append Transaction Fee')}
                                        control={control}
                                    />
                                    <WysiwygFieldController
                                        subLabel={Localization.getString(
                                            'This information goes onto the confirmation voucher',
                                        )}
                                        toolTip={Localization.getString('NoteToClientPostBToolTip')}
                                        label={Localization.getString('Notes To Clients Post Booking')}
                                        name={nameof<Offer>('notesToClientsPostBooking')}
                                        control={control}
                                    />
                                    <WysiwygFieldController
                                        label={Localization.getString('Pick Up Meeting Point Information')}
                                        name={nameof<Offer>('pickUpMeetingPointInformation')}
                                        control={control}
                                    />
                                    <MediaSelector
                                        heroImageId={heroImageId}
                                        onHeroImageChanged={onHeroImageChanged}
                                        selected={photos}
                                        onSelectPhotos={onSelectPhotos}
                                        onDelete={onDeletePhoto}
                                    />
                                </Card>
                            </Col>
                            <Col isNoMargin type="50">
                                <Card>
                                    <WysiwygFieldController
                                        label={Localization.getString('Description')}
                                        name={nameof<Offer>('description')}
                                        control={control}
                                    />
                                </Card>
                                <Card>
                                    <h3>{Localization.getString('Age Policy & Attraction Tickets')}</h3>

                                    <ToggleFieldController
                                        name={nameof<Offer>('childrenAllowed')}
                                        label={Localization.getString('Children allowed')}
                                        control={control}
                                    />
                                    <NumberFormField
                                        register={register}
                                        defaultValue={offer.childAge}
                                        label={Localization.getString('Child Age, Before')}
                                        isRequired
                                        min={1}
                                        max={18}
                                        name={nameof<Offer>('childAge')}
                                    />
                                    <ToggleFieldController
                                        name={nameof<Offer>('infantsAllowed')}
                                        label={Localization.getString('Infants allowed')}
                                        control={control}
                                    />
                                    <NumberFormField
                                        register={register}
                                        defaultValue={offer.infantAge}
                                        label={Localization.getString('Infant Age, Before')}
                                        isRequired
                                        min={1}
                                        max={18}
                                        name={nameof<Offer>('infantAge')}
                                    />
                                    <ToggleFieldController
                                        name={nameof<Offer>('isTicketsRequired')}
                                        label={Localization.getString('Are attraction tickets required for this ticket?')}
                                        control={control}
                                        onChange={(e: boolean) => {
                                            // if (!e) {
                                            //     setValue('ticketTypeAdult', undefined as any)
                                            //     setValue('ticketTypeChild', undefined as any)
                                            //     setValue('ticketTypeInfant', undefined as any)
                                            // }
                                        }}
                                    />
                                    {data.isTicketsRequired && (
                                        <SelectFormFieldController
                                            name={nameof<Offer>('ticketTypesAdult')}
                                            label={Localization.getString('Adult ticket')}
                                            options={ticketsOptions}
                                            isRequired
                                            isMultiple
                                            control={control}
                                        />
                                    )}
                                    {data.isTicketsRequired && (
                                        <SelectFormFieldController
                                            name={nameof<Offer>('ticketTypesChild')}
                                            label={Localization.getString('Child ticket')}
                                            isRequired
                                            options={ticketsOptions}
                                            isMultiple
                                            control={control}
                                        />
                                    )}
                                    {data.isTicketsRequired && (
                                        <SelectFormFieldController
                                            name={nameof<Offer>('ticketTypesInfant')}
                                            label={Localization.getString('Infant ticket')}
                                            isRequired
                                            isMultiple
                                            options={ticketsOptions}
                                            control={control}
                                        />
                                    )}
                                    <TextFormField
                                        label={Localization.getString('Trip Unit')}
                                        subLabel={Localization.getString('If specified and offer has price per trip then prices will be shown as "Price Per {Trip Unit}"')}
                                        isRequired
                                        register={register}
                                        name={nameof<Offer>('tripUnit')}
                                    />
                                </Card>
                                <Card>
                                    <h3>{Localization.getString('Availability settings')}</h3>
                                    {auth.authData?.isExternalIntegrations && <ToggleFieldController
                                        name={nameof<Offer>('isManulExternalLink')}
                                        label={Localization.getString('Link to external offer')}
                                        control={control}
                                    />}
                                    {data.isManulExternalLink || (data.externalOfferId && data.externalProviderId)
                                    ? <>
                                            <SelectFormFieldController
                                                name={nameof<Offer>('externalProviderId')}
                                                label={Localization.getString('External provider')}
                                                options={externalProviders}
                                                control={control}
                                                disabled={!data.isManulExternalLink}
                                                onChange={onExternalProviderChanged}
                                            />
                                            <SelectFormFieldController
                                                name={nameof<Offer>('externalTourId')}
                                                label={Localization.getString('External tour ID')}
                                                options={externalProducts}
                                                control={control}
                                                disabled={!data.isManulExternalLink}
                                                onChange={onExternalTourChanged}
                                            />      
                                            {data.externalTourId && externalProductDetails && 
                                            <SelectFormFieldController
                                                name={nameof<Offer>('externalOfferId')}
                                                label={Localization.getString('External offer ID')}
                                                options={externalProductDetails.offers?.map(x => ({
                                                    label: `${x.nameDisplay ?? "NO NAME"} (${x.externalId ?? "NO ID"})`,
                                                    value: String(x.externalId ?? "NO ID"),
                                                })) || []}
                                                control={control}
                                                disabled={!data.isManulExternalLink}
                                                onChange={onExternalOfferChanged}
                                            />
                                            }                             
                                            {hasExternalTicketTypes && (
                                                <SelectFormFieldController
                                                    name={nameof<Offer>('externalTicketTypeAdultId')}
                                                    label={Localization.getString('External Ticket Per Adult')}
                                                    options={externalTicketTypeOptions}
                                                    control={control}
                                                    disabled={!data.isManulExternalLink}
                                                />
                                            )}
                                            {hasExternalTicketTypes && data.childrenAllowed && (
                                                <SelectFormFieldController
                                                    name={nameof<Offer>('externalTicketTypeChildId')}
                                                    label={Localization.getString('External Ticket Per Child')}
                                                    options={externalTicketTypeOptions}
                                                    control={control}
                                                    disabled={!data.isManulExternalLink}
                                                />
                                            )}
                                            {hasExternalTicketTypes && data.infantsAllowed && (
                                                <SelectFormFieldController
                                                    name={nameof<Offer>('externalTicketTypeInfantId')}
                                                    label={Localization.getString('External Ticket Per Infant')}
                                                    options={externalTicketTypeOptions}
                                                    control={control}
                                                    disabled={!data.isManulExternalLink}
                                                />
                                            )}
                                        </>
                                    : <>
                                    <SelectFormFieldController
                                        name={nameof<Offer>('bookingType')}
                                        label={Localization.getString('Booking Type')}
                                        options={BookingTypeOptions}
                                        control={control}
                                    />
                                    <SelectFormFieldController
                                        name={nameof<Offer>('timeSlots')}
                                        label={Localization.getString('Time Slots')}
                                        isMultiple
                                        options={timeSlotsOptions}
                                        control={control}
                                        isRequired={data.bookingType == BookingType.LiveBook}
                                        rules={{
                                            validate: (value: any) => {
                                                return (value && value.length > 0 || data.bookingType != BookingType.LiveBook)
                                                    ? undefined
                                                    : "At least one time slot is required for live book"
                                            }
                                        }}
                                        error={errors.timeSlots ? (errors.timeSlots as any).message : ''}
                                    />
                                    {data.privateType == OfferPrivateType.Private
                                    ? <ToggleFieldController
                                        name={nameof<Offer>('isMultipleUnitsAllowed')}
                                        label={Localization.getString('Multiple units allowed')}
                                        control={control}
                                    />
                                    : undefined}
                                    </>}                                    
                                </Card>
                                <Card>
                                    <h3>{Localization.getString('Add-ons:')}</h3>
                                    <ToggleFieldController
                                        name={nameof<Offer>('isAddonOnly')}
                                        label={Localization.getString('Add-on only offer')}
                                        control={control}
                                    />
                                    <SelectFormFieldController
                                        name={nameof<Offer>('addons')}
                                        label={Localization.getString('Add-ons:')}
                                        options={offersOptions}
                                        isMultiple
                                        control={control}
                                    />

                                    {offer.addonFor && offer.addonFor.length
                                        ? <FormFieldWrapper>
                                            <label>Add-on for:</label>
                                            {offer.addonFor.map(o => <p key={o}>{offersOptions.find(x => x.value == o)?.label ?? "Unknown offer"}</p>)}
                                        </FormFieldWrapper>
                                        : null}
                                </Card>                               
                                <Card>
                                    <h3>{Localization.getString('Cancellation Policy')}</h3>
                                    <ToggleButtonsSmallFieldController
                                        noText={
                                            tour?.cancellationPolicy && tour.cancellationPolicy.length > 0 ? (
                                                Localization.getString('Use tour defaults')
                                            ) : (
                                                <NoDefaultValue />
                                            )
                                        }
                                        yesText={Localization.getString('Use custom')}
                                        name={nameof<Offer>('isOverrideTourCancellationPolicy')}
                                        label={''}
                                        control={control}
                                        onChange={(value) => {
                                            if (value) {
                                                setCancellation(tour?.cancellationPolicy || [])
                                            }
                                            return value
                                        }}
                                    />
                                    <Cancellations
                                        onChange={(cancellations: CancellationPolicy[]) => {
                                            setCancellation(cancellations)
                                        }}
                                        isReadOnly={!data.isOverrideTourCancellationPolicy}
                                        cancellations={data.isOverrideTourCancellationPolicy ? cancellation : tour?.cancellationPolicy || []}
                                    />
                                    {!data.isOverrideTourCancellationPolicy && <Link to={`/tours/${props.match.params.tourId}`}>Edit tour cancellation policy</Link>}
                                </Card>
                            </Col>
                        </Row>
                        {previewLanguageId <= 0 ? (
                            <Buttons.StickySaveButton>{Localization.getString('Save')}</Buttons.StickySaveButton>
                        ) : (
                            <Buttons.StickySaveButton
                                onClick={(e) => {
                                    e.preventDefault()
                                    setPreviewLanguageId(0)
                                }}>
                                {Localization.getString('Switch Back To Main Language')}
                            </Buttons.StickySaveButton>
                        )}
                    </form>
                </Grid>
            ) : (
                <LoadingSection />
            )}
        </ContainerWithPadding>
    )
}
export default OfferForm
